var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import ENV from 'config/env';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
// Components
import Icon from 'common/UIToolKit/Icon.vue';
import { Company } from 'packages/company/entities/Company';
import { FeatureConfiguration } from 'packages/features/FeatureConfiguration';
import { User } from 'packages/users/User';
import { container } from 'tsyringe';
import AppLink from 'ui/v1/navigation/AppLink.vue';
import { Getter, namespace, State } from 'vuex-class';
import NotificationsBadge from './notifications/NotificationsBadge.vue';
import NotificationsFlyout from './notifications/NotificationsDrawer.vue';
import AccountFlyout from './sidebar/AccountFlyout.vue';
import CompanySwitcherFlyout from './sidebar/CompanySwitcher.vue';
import BetaFlyout from 'components/beta/BetaFlyout.vue';
import Permissions from 'common/support/Permissions';
var profileModule = namespace('profile');
var company = namespace('companyModule');
var beta = namespace('beta');
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authenticator = container.resolve(Authenticator);
        _this.permissions = container.resolve(Permissions);
        _this.urls = {
            settings: {
                path: ENV.APPS.SETTINGS.URL,
            },
            ats: {
                path: ENV.APPS.PRODUCT.URL + "jobs",
            },
            eb: {
                path: ENV.APPS.EB.URL,
            },
            candidatePool: {
                path: ENV.APPS.CANDIDATE_POOL.URL,
            },
            jobList: {
                path: ENV.APPS.PRODUCT.URL + "job-lists",
            },
            profile: {
                path: ENV.APPS.PRODUCT.URL + "profile",
            },
            dashboard: {
                path: "" + ENV.APPS.PRODUCT.URL,
            },
            analytics: {
                path: ENV.APPS.PRODUCT.URL + "analytics",
            },
            accountSettings: {
                path: ENV.APPS.PRODUCT.URL + "profile/overview",
            },
        };
        return _this;
    }
    Object.defineProperty(Sidebar.prototype, "hasBetaAccess", {
        get: function () {
            return this.hasActiveBetas && this.permissions.isJobillaUser;
        },
        enumerable: false,
        configurable: true
    });
    Sidebar.prototype.applyHolidayEffect = function () {
        var _this = this;
        setTimeout(function () {
            _this.holidayHelper().applyScreenEffect();
        }, 1000);
    };
    Sidebar.prototype.logNavigationToEb = function () {
        var _a;
        this.$app.dataDogLogger.info('feature.nav.eb', {
            role: this.user.role,
            unit: (_a = this.user.unit) === null || _a === void 0 ? void 0 : _a.name,
            company_id: this.currentCompanyId,
            company_name: this.company.name,
            user_id: this.user.id,
            user_name: this.user.name,
            user_email: this.user.email,
        });
        this.$posthog.capture('Employer branding clicked', {}, { send_instantly: true });
    };
    Sidebar.prototype.companyUpdated = function () {
        this.$forceUpdate();
    };
    var _a, _b, _c;
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof FeatureConfiguration !== "undefined" && FeatureConfiguration) === "function" ? _a : Object)
    ], Sidebar.prototype, "features", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], Sidebar.prototype, "currentCompanyId", void 0);
    __decorate([
        beta.Getter,
        __metadata("design:type", Boolean)
    ], Sidebar.prototype, "hasActiveBetas", void 0);
    __decorate([
        beta.Getter,
        __metadata("design:type", Boolean)
    ], Sidebar.prototype, "isBetaActiveForCurrentUser", void 0);
    __decorate([
        profileModule.State,
        __metadata("design:type", Boolean)
    ], Sidebar.prototype, "loading", void 0);
    __decorate([
        profileModule.State,
        __metadata("design:type", typeof (_b = typeof User !== "undefined" && User) === "function" ? _b : Object)
    ], Sidebar.prototype, "user", void 0);
    __decorate([
        company.State,
        __metadata("design:type", typeof (_c = typeof Company !== "undefined" && Company) === "function" ? _c : Object)
    ], Sidebar.prototype, "company", void 0);
    __decorate([
        company.Action,
        __metadata("design:type", Function)
    ], Sidebar.prototype, "getCompany", void 0);
    __decorate([
        Inject(),
        __metadata("design:type", Function)
    ], Sidebar.prototype, "holidayHelper", void 0);
    __decorate([
        Watch('companyId', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Sidebar.prototype, "companyUpdated", null);
    Sidebar = __decorate([
        Component({
            components: {
                BetaFlyout: BetaFlyout,
                Icon: Icon,
                AppLink: AppLink,
                AccountFlyout: AccountFlyout,
                NotificationsBadge: NotificationsBadge,
                NotificationsFlyout: NotificationsFlyout,
                CompanySwitcherFlyout: CompanySwitcherFlyout,
            },
        })
    ], Sidebar);
    return Sidebar;
}(Vue));
export default Sidebar;
